import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import type { Room } from "@/react/types/Live/Room";
import { internalApi } from "@circle-react/helpers/urlHelpers/internalApi";

interface RoomParams {
  id?: string;
}

interface UseGetLiveStreamRoomReturn {
  error: Error | null;
  isLoading: boolean;
  room: Room | null;
  roomId: string | undefined;
}

export const useGetLiveStreamRoom = (): UseGetLiveStreamRoomReturn => {
  const { id } = useParams<RoomParams>();

  const {
    data: room,
    isLoading,
    error,
  } = useQuery<Room, Error>(internalApi.liveStreams.show({ id }), {
    enabled: !!id,
    retry: false,
  });

  return {
    error: error || null,
    isLoading: isLoading && !!id,
    room: room || null,
    roomId: id,
  };
};
